/* global fetch $  */
import $ from "jquery";
import { messageEllipse, messagefromSystem, initBotInstance, messagefromBot } from "./dialog_messages.js";
import { getConfig, checkNested } from "../general_functions.js";
import { setScrollBottom, getMetaValue } from "./dialog_general.js";
import { getAimData } from "./dialog_aim.js";
import language from "../translation";
import { getMetadataValue } from "../search";


export const search = (val = "*") => {

    // console.log("test repeat");

    // messagefromSystem(language("ERROR_ILLTRY_SEARCH"));

    // messageEllipse();

    let searchOn = $.trim(val);

    let config = getConfig();

    const siteConfig = getConfig();

    //Add filter on language
    if (client.lang == undefined) {
        client.lang = "nb";
    }

    $.ajax({
        type: "POST",
        headers: {
            "ApiKey": 'f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45',
            "Content-Type": "application/graphql"
        },
        url: searchEngine,
        data: `
                query {      
                    index {
                        items (
                            filter: {
                                searchQuery: "${searchOn}",       
                                skip: 0,
                                take: 3,
                                queryType: MATCHANY,
                                sortBy: RELEVANCE,
                                categories: [
                                   { values: ["contentSubscribers", "${config.clientId}"] },
                                   { values: ["Language", "${client.lang}_no"] }
                                ]
                            }                 
                        )    
                        {
                            hits,results {
                                title, date, content, id, url, relevance, extracts, 
                                metadata {
                                    name, value
                                },
                                categories {
                                    values
                                }
                            }
                        }
                    } 
                }`,
        success: function(data) {


            // messageEllipse("stop");

            // data = data.data;



            if (checkNested(data, "index", "items")) {

                // console.log()

                let result = data.data.index.items;

                console.log("søkeresultat", result);

                let newOb = {
                    data: {
                        index: {
                            items: {
                                // results: [data[0]]
                            }
                        }
                    }
                };

                // window.messagesToShow.push({id: createGuid(), html : messagefromBot({ type: "searchlinks", payload: newOb.data })})
                // CHANGECONV $("#kari__dialog__window").append(messagefromBot({ type: "searchlinks", payload: newOb.data }));
                // messagequeue.push(messagefromBot({ type: "searchlinks", payload: newOb.data }, false, "bot__searchresult"))

                //     let hits = data.index.items.hits;
                //     let res_ = data.index.items.results;


                //     let pagetype = false;
                //     if (checkNested(res_[0], "metadata")) {
                //         pagetype = getMetaValue(res_[0].metadata, "PageTypeId");
                //     }

                //     if (res_.length === 1 && pagetype === "mal_blokk") {

                //         messagefromSystem(language("RESULTS_FROM_WEBSEARCH"));

                //         let id = getMetadataValue(res_[0], "ContentId")
                //         console.log("TEST");

                //         getAimData(id, siteConfig.servioId);

                //     }
                //     else if (res_.length > 1 && hits <= 3) {

                //         messagefromSystem(language("RESULTS_FROM_WEBSITE_ANSWER"));
                //         $("#kari__dialog__window").append(messagefromBot({ type: "searchlinks", payload: data }));

                //     }
                //     else if (res_.length > 1 && res_.length <= hits) {

                //         messagefromSystem(language("MANY_ANSWERS_P1") + " (" + hits + "). " + language("MANY_ANSWERS_P2"));
                //         $("#kari__dialog__window").append(messagefromBot({ type: "searchlinks", payload: data }));
                //         messagefromSystem("<a href='/search/" + searchOn + "'>Gå til søk</a>");


                //     }
                //     else if (res_.length < 1) {
                //         messagefromSystem(language("NO_ANSWER_QUERY"));
                //     }
                //     else {
                //         messagefromSystem(language("ERROR_WHILE_SEARCH"));
                //     }
                //     $(".removewhendone").remove();
                // }
                // else {
                //     console.error("No matches");
                // }
                // setScrollBottom();
            }
        }
    });
};
